import './unregister/unregister';
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import './plugins/vue-awesome-swiper';
import "@/assets/style/style.sass"
import auth from '@/models/modules/auth/index';
import lang from '@/models/modules/lang/index';
import i18n from '@/plugins/i18n/i18n';
import VTooltip from 'v-tooltip';
import './plugins/firebasenotify';

Vue.use(VTooltip);

Vue.config.productionTip = false;

auth.init();
lang.init();

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount("#app");
